// extracted by mini-css-extract-plugin
export default {"pageWrapper":"leadCardDetails_pageWrapper__wVp-Y","container":"leadCardDetails_container__SKiQp","message":"leadCardDetails_message__zZbOb","date":"leadCardDetails_date__yk6kS"};